
const HomePageRouters = [
  { path: '/adminPreserve', component: () => import('@/views/HomePage/AdminPreserve') },
  { path: '/hqsyshome', component: () => import('@/views/HomePage/HQSysHome/index.vue') },
  { path: '/rolemanage', component: () => import('@/views/HomePage/RoleManage/index.vue') },
  { path: '/adminorder', component: () => import('@/views/HomePage/AdminOrder/index.vue') },
  { path: '/adminmaintenance', component: () => import('@/views/HomePage/AdminMaintenance/index.vue') },
  { path: '/editroles', component: () => import('@/views/HomePage/EditRoles/index.vue') },
  { path: '/membermanage', component: () => import('@/views/HomePage/MemberManage/index.vue') }
]

export default HomePageRouters
